"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const order_1 = require("@/api/order");
const date_1 = require("@/utils/date");
const index_vue_1 = __importDefault(require("@/components/SalesMan/index.vue"));
let Orders = class Orders extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.orderData = [];
        this.total = 0;
        this.multipleSelection = [];
        this.params = {
            content: '',
            loginToken: this.userInfo.loginToken,
            pageNo: 1,
            pageSize: 10,
            status: ''
        };
        this.dialogVisible = false;
        this.contacInfo = {
            email: "",
            faceBook: "",
            lastOnlineTime: '',
            phone: "",
            qqmsn: "",
            skype: "",
            wechat: "",
            whatsApp: ""
        };
    }
    goDetail(row) {
        let routeData = this.$router.resolve(`/goodDetail/${row.itemNo}`);
        window.open(routeData.href, '_blank');
        // this.$router.push(`/goodDetail/${row.itemNo}`)
    }
    getContact(id) {
        order_1.getContact({ id: id, loginToken: this.userInfo.loginToken, type: 1 }).then(res => {
            this.contacInfo = JSON.parse(JSON.stringify(res));
            this.dialogVisible = true;
        });
    }
    handleClose() {
        this.dialogVisible = false;
    }
    getDate(date) {
        return date_1.getDateStr(date);
    }
    handleSelect(status) {
        this.params.pageNo = 1;
        this.params.status = status;
        this.getList();
    }
    handleCurrentChange(val) {
        this.params.pageNo = val;
        this.getList();
    }
    orderDetail(id) {
        sessionStorage.setItem('quoted', 'yes');
        const routeLink = this.$router.resolve({
            path: `/orderDetail/${id}`
        });
        window.open(routeLink.href, '_blank');
        // this.$router.push(`/orderDetail/${id}`)
    }
    cancelOrder(id) {
        this.$confirm('This operation will permanently delete the order. Do you want to continue?', 'prompt', {
            confirmButtonText: 'confirm',
            cancelButtonText: 'cancel',
            type: 'warning'
        }).then(() => {
            order_1.deleteQuo({ ids: id, loginToken: this.userInfo.loginToken }).then(res => {
                this.getList();
                this.$message({
                    type: 'success',
                    message: 'Delete succeeded!'
                });
            });
        }).catch(() => { });
    }
    getList() {
        order_1.getQuoList(this.params).then(res => {
            this.orderData = res.list;
            // console.log(res.list)
            this.total = res.totalCount;
            // ;(document.querySelector('meta[name="keywords"]') as any).setAttribute('content', res.tkd.keywords || '')
            // ;(document.querySelector('meta[name="description"]') as any).setAttribute('content', res.tkd.description || '')
            // document.title = res.tkd.title || ''
        });
    }
    viewContract(a) {
        window.open(a, '_blank');
    }
    mounted() {
        this.userInfo.loginToken && this.getList();
    }
};
Orders = __decorate([
    vue_property_decorator_1.Component({
        components: { SalesMan: index_vue_1.default }
    })
], Orders);
exports.default = Orders;
